import { Box } from '@mui/material';
import { ButtonUI, DatePickerUI, DialogUI, FormLabelUI } from '../../../Interface';
import { useState } from 'react';

const DateDialog = ({ open, handleClose, onSave }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const onClose = () => {
    setSelectedDate(null);
    handleClose();
  };

  return (
    <DialogUI
      open={open}
      onClose={onClose}
      headerContent="Dátum kiválasztása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '400px',
          },
        },
      }}
    >
      <Box>
        <DatePickerUI label={<FormLabelUI text="Dátum" />} onChange={(newVal) => setSelectedDate(newVal)} />

        <Box display="flex" gap="0.5rem" justifyContent="center" mt={1.5}>
          <ButtonUI
            text="Mentés"
            className="bg-success"
            disabled={!selectedDate}
            onClick={() => onSave?.(selectedDate)}
          />
          <ButtonUI text="Bezárás" className="bg-primary" onClick={onClose} />
        </Box>
      </Box>
    </DialogUI>
  );
};

export default DateDialog;
